
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iDxDj", function(module, exports) {

$parcel$export(module.exports, "EditorContentState", () => $f084987bc41bc5d5$export$2791e79b1a186ba4);

var $gwFzn = parcelRequire("gwFzn");

var $ipPpS = parcelRequire("ipPpS");

var $diswb = parcelRequire("diswb");

var $inPa6 = parcelRequire("inPa6");

var $dIouf = parcelRequire("dIouf");

var $3jwuS = parcelRequire("3jwuS");



var $qP1yw = parcelRequire("qP1yw");

var $bJX6u = parcelRequire("bJX6u");

var $bd27Q = parcelRequire("bd27Q");
const $f084987bc41bc5d5$var$EditorContentStateDataGetter = ({ contentId: contentId, contentType: contentType, contentStateState: contentStateState, isPublishingContent: isPublishingContent, userOffline: userOffline, onContentStateMenuToggle: onContentStateMenuToggle, floatingToolbarButtonStyle: floatingToolbarButtonStyle, renderPlusButtonEmptyState: renderPlusButtonEmptyState, isDetailsPanel: isDetailsPanel })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isCurrentPageLive = (0, $3jwuS.useIsCurrentPageLive)();
    const { data: data } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $bd27Q.EditorContentStateQuery), {
        fetchPolicy: Boolean(window.__SSR_RENDERED__) ? 'cache-first' : 'network-only',
        variables: {
            contentId: contentId,
            isDraft: !isCurrentPageLive
        },
        skip: !contentStateState.state.shouldRunContentStateEffect
    });
    (0, $gwFzn.useEffect)(()=>{
        if (data && contentStateState.state.shouldRunContentStateEffect) {
            const newContentStateValues = Object.assign({}, (0, $bJX6u.defaultValues));
            /* EditorContentState is rendered in the breadcrumbs & title area content components based on if a page has a content
      state or not. The re-render from the change in parent causes the useEffect and query to run again, resetting the values.
      To prevent this, we have the shouldRunContentStateEffect state. If we are inside the if statement, it means it's the first time
      we're fetching (aka first page load). Since we already ran the effect once, don't do it again since otherwise it
      will cause a values reset. */ newContentStateValues.shouldRunContentStateEffect = false;
            newContentStateValues.contentState = data?.singleContent?.contentState || null;
            newContentStateValues.defaultStatesArray = data?.availableContentStates?.spaceContentStates || [];
            newContentStateValues.customStatesArray = data?.availableContentStates?.customContentStates || [];
            // If an admin has turned off a toggle, BE returns us the value as null
            // If an empty array is returned [], means the feature is still enabled - there's just no values in there.
            // if both return as null it means the admin disabled content states
            const isSuggestedContentStatesDisabled = !data?.availableContentStates?.spaceContentStates;
            const isCustomContentStatesDisabled = !data?.availableContentStates?.customContentStates;
            const isContentStatesDisabled = isSuggestedContentStatesDisabled && isCustomContentStatesDisabled;
            if (isContentStatesDisabled) newContentStateValues.isContentStateEnabled = false;
            else if (isSuggestedContentStatesDisabled) // if spaceContentStates is null, admin disabled suggested
            newContentStateValues.isSuggestedEnabled = false;
            else if (isCustomContentStatesDisabled) // if customContentStates is null, admin disabled custom
            newContentStateValues.isCustomEnabled = false;
            contentStateState.setInitialValues(newContentStateValues);
        }
    }, [
        data,
        contentStateState
    ]);
    if (isPublishingContent) // isPublishingContent is an optional prop that we only pass to this component if a page has a content state.
    // Therefore if it's true, means we're publishing a page with a content state so fire the analytic event
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: 'publishedWithContentState',
            actionSubject: 'page',
            objectId: contentId,
            source: 'editorContentState'
        }
    }).fire();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $qP1yw.LazyEditorContentStateComponent), {
        contentId: contentId,
        contentType: contentType,
        contentStateState: contentStateState,
        userOffline: userOffline,
        onContentStateMenuToggle: onContentStateMenuToggle,
        floatingToolbarButtonStyle: floatingToolbarButtonStyle,
        renderPlusButtonEmptyState: renderPlusButtonEmptyState,
        isDetailsPanel: isDetailsPanel
    });
};
const $f084987bc41bc5d5$var$EditorContentStateWithErrorBoundary = (0, $dIouf.withTransparentErrorBoundary)({
    attribution: (0, $dIouf.Attribution).PAGE_EXTENSIONS
})($f084987bc41bc5d5$var$EditorContentStateDataGetter);
const $f084987bc41bc5d5$export$2791e79b1a186ba4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $bJX6u.ContentStateStateContainer)
        ]
    }, (contentStateState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($f084987bc41bc5d5$var$EditorContentStateWithErrorBoundary, {
            ...props,
            contentStateState: contentStateState
        }));

});
parcelRegister("qP1yw", function(module, exports) {

$parcel$export(module.exports, "LazyEditorContentStateComponent", () => $d4d6077acc6972b1$export$a5601a59fc831df9);
$parcel$export(module.exports, "LazyRendererContentStateWithSpotlight", () => $d4d6077acc6972b1$export$37b2a2676143157);

var $jmjWc = parcelRequire("jmjWc");

var $dzxx6 = parcelRequire("dzxx6");

const $d4d6077acc6972b1$export$a5601a59fc831df9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "qET7f",
    name: "LazyEditorContentStateComponent",
    loader: async ()=>{
        return (await (parcelRequire("2oM8h"))).EditorContentStateComponent;
    }
});

const $d4d6077acc6972b1$export$37b2a2676143157 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Ul2WW",
    name: "LazyRendererContentStateWithSpotlight",
    loader: async ()=>{
        return (await (parcelRequire("3o9Zt"))).RendererContentStateWithSpotlight;
    },
    loading: (0, $dzxx6.RendererContentStatePlaceholder)
});

});
parcelRegister("dzxx6", function(module, exports) {

$parcel$export(module.exports, "RendererContentStatePlaceholder", () => $62a49c8d20755563$export$6679211e6c7373d);
/* RendererContentStatePlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $3jwuS = parcelRequire("3jwuS");

var $6mKj3 = parcelRequire("6mKj3");
const $62a49c8d20755563$var$loadingPlaceholderBaseStyles = (0, $ecnYn.xcss)({
    cursor: 'pointer',
    minHeight: '32px',
    borderRadius: '3px',
    paddingRight: 'space.100'
});
const $62a49c8d20755563$var$placeHolderBackroundColorStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral'
});
const $62a49c8d20755563$var$subtlePlaceholderBackgroundColorStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'utility.elevation.surface.current'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $62a49c8d20755563$var$ContentStateNamePlaceholderWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_k48p1wq8 _3um015vq",
            __cmplp.className
        ])
    });
});
const $62a49c8d20755563$var$classicContentStateColorPlaceholderStyles = (0, $ecnYn.xcss)({
    borderRadius: '12px',
    height: '12px',
    width: '12px',
    marginTop: 'space.0',
    marginBottom: 'space.0',
    marginLeft: 'space.100',
    marginRight: 'space.100',
    backgroundColor: 'color.background.neutral'
});
const $62a49c8d20755563$var$subtleContentStateColorPlaceholderStyles = (0, $ecnYn.xcss)({
    borderRadius: '10px',
    height: '10px',
    width: '10px',
    marginLeft: 'space.050',
    marginRight: 'space.075',
    backgroundColor: 'color.background.neutral'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $62a49c8d20755563$var$StyledBorder = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_18s81b3y _1kl7gzey _1e0c1o8l _1bsbt94y _4t3i7vkz _1wpz1h6o",
            __cmplp.className
        ])
    });
});
const $62a49c8d20755563$var$flexWrapperStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.075',
    marginRight: 'space.075'
});
const $62a49c8d20755563$export$6679211e6c7373d = ({ contentState: contentState, isDraft: isDraft })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const contentStateLoadingPlaceholderStyles = [
        $62a49c8d20755563$var$loadingPlaceholderBaseStyles,
        isLivePage || (0, $6mKj3.expValEquals)('cc-page-experiences-new-renderer-byline', 'cohort', 'test') ? $62a49c8d20755563$var$subtlePlaceholderBackgroundColorStyles : $62a49c8d20755563$var$placeHolderBackroundColorStyles
    ];
    const contentStateColorPlaceholderStyles = [
        isLivePage || (0, $6mKj3.expValEquals)('cc-page-experiences-new-renderer-byline', 'cohort', 'test') ? $62a49c8d20755563$var$subtleContentStateColorPlaceholderStyles : $62a49c8d20755563$var$classicContentStateColorPlaceholderStyles
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        xcss: $62a49c8d20755563$var$flexWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        as: "li",
        alignItems: "center" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        ,
        xcss: contentStateLoadingPlaceholderStyles,
        testId: isLivePage || (0, $6mKj3.expValEquals)('cc-page-experiences-new-renderer-byline', 'cohort', 'test') ? 'subtle-renderer-content-state-placeholder' : 'renderer-content-state-placeholder'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    ), {
        xcss: contentStateColorPlaceholderStyles,
        testId: isLivePage || (0, $6mKj3.expValEquals)('cc-page-experiences-new-renderer-byline', 'cohort', 'test') ? 'subtle-renderer-content-state-color-placeholder' : 'renderer-content-state-color-placeholder'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($62a49c8d20755563$var$ContentStateNamePlaceholderWrapper, null, contentState?.name)), !isDraft && !(0, $6mKj3.expValEquals)('cc-page-experiences-new-renderer-byline', 'cohort', 'test') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($62a49c8d20755563$var$StyledBorder, {
        "data-testid": "placeholder-vertical-line"
    }));
};

});

parcelRegister("2oM8h", function(module, exports) {

let $1bf328ccf75ab32a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $1bf328ccf75ab32a$var$load("02lUE"),
    $1bf328ccf75ab32a$var$load("c6MKV"),
    $1bf328ccf75ab32a$var$load("aZinD"),
    $1bf328ccf75ab32a$var$load("4Pn6Z"),
    $1bf328ccf75ab32a$var$load("9DDT5")
]).then(()=>parcelRequire('2TweP'));

});

parcelRegister("3o9Zt", function(module, exports) {

let $277b5ce6565018c9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $277b5ce6565018c9$var$load("daCl8"),
    $277b5ce6565018c9$var$load("4gtMV"),
    $277b5ce6565018c9$var$load("YUxKy"),
    $277b5ce6565018c9$var$load("azlpK")
]).then(()=>parcelRequire('gZHbC'));

});




//# sourceMappingURL=EditorContentState.79c87c21.js.map
